import { Navigate, useLocation } from 'react-router-dom';
import { FD_MAP_MODE_HISTORY, fdPaths } from './routes';

/**
 * Old preview URLs that CO-910 folded into another page. Each lands on the page that now shows the
 * same thing, so a bookmark or a link in a demo script is never a dead end. Named `...Redirect` so
 * `scripts/nav-catalog-audit.mjs` classes these rows as redirects, not as pages to catalogue.
 */

/** `/fleet/vehicle-history?vehicle=&trip=` → the Live Map's History mode, keeping the van and trip. */
export function FdVehicleHistoryRedirect() {
  const { search, hash } = useLocation();
  const params = new URLSearchParams(search);
  params.set('mode', FD_MAP_MODE_HISTORY);
  return <Navigate to={`${fdPaths.fleetLiveMap()}?${params.toString()}${hash}`} replace />;
}
